import Plugin, { init } from "@/modules/_utils/Plugin";

class header extends Plugin {
  init() {
    const nav = document.querySelectorAll(".hamburger");

    function clickHandler(e) {
      this.classList.toggle("is-active");
      document.body.classList.toggle("mobile__overlay");
    }

    Array.prototype.forEach.call(nav, function(menu) {
      menu.addEventListener("click", clickHandler);
    });
  }
}

export default init(header, "headerScreen");
